<template>
  <div class="project-staff-manage">
    <el-tabs v-model="activeIndex" v-if="!projectStaffInfoId">
      <el-tab-pane label="集团员工" name="first">
        <project-internal-staff-manage ref="projectInternalStaffManage" @showProjectStaffInfo="showProjectStaffInfo"></project-internal-staff-manage>
      </el-tab-pane>
      <el-tab-pane label="外部员工" name="second">
        <project-external-staff-manage></project-external-staff-manage>
      </el-tab-pane>
    </el-tabs>
    <project-staff-info v-else :id="projectStaffInfoId" @cancel="projectStaffCancel"></project-staff-info>
  </div>
</template>

<script>
  import ProjectInternalStaffManage from '@/views/ProjectInternalStaffManage.vue';
  import ProjectExternalStaffManage from '@/views/ProjectExternalStaffManage.vue';
  import ProjectStaffInfo from '@/views/ProjectStaffInfo.vue'

  export default {
    name: 'ProjectStaffManage',
    data() {
      return {
        projectStaffInfoId: null,
        activeIndex: 'first'
      }
    },
    components: {
      ProjectInternalStaffManage,
      ProjectExternalStaffManage,
      ProjectStaffInfo
    },
    methods: {
      showProjectStaffInfo(id) {
        this.projectStaffInfoId = id;
      },
      projectStaffCancel() {
        this.projectStaffInfoId = null;
      }
    },
  }
</script>

<style lang="less" scoped>
  @import '../assets/styles/tools.less';
  .project-staff-manage {
    /deep/ .el-tabs {
      .el-tabs__header {
        margin: 0;
        .el-tabs__nav-wrap {
          .el-tabs__nav-scroll {
            .el-tabs__nav {
              .el-tabs__item {
                line-height: initial;
                height: 30px;
              }
            }
          }
        }
      }
    }
  }
</style>